import firebase from 'firebase/app'

// These imports load individual services into the firebase namespace.
import 'firebase/database'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/auth'

const app = firebase.initializeApp({
  apiKey: 'AIzaSyBbMV7q7iiKli5SDvpRSmLe6Ys7AAYyxnY',
  authDomain: 'engineer-ae17e.firebaseapp.com',
  databaseURL: 'https://engineer-ae17e.firebaseio.com',
  projectId: 'engineer-ae17e',
  storageBucket: 'engineer-ae17e.appspot.com',
  messagingSenderId: '93857944365'
})
app.firestore().enablePersistence()

export const firedb = app.database()
export const fireStore = app.firestore()
export const connectedRef = app.database().ref('.info/connected')
export const storage = app.storage()
export const auth = app.auth()



// WEBPACK FOOTER //
// ./src/firebase.js